export default [
  {
    id: '19c709bb-241d-4437-bc71-cdbd1b147745', // id 全局唯一，终身制
    name: 'visualizationTongreVulkan',
    path: '/visualization-tongre-vulkan',
    meta: { title: '三维可视化' },
    layout: 'fullscreen',
    // 根菜单不需要定义 component，由主框架定义
    children: [
      {
        id: '49900e40-ea5f-4b9e-b2af-ee938f6617f4',
        path: 'index',
        name: 'TongreVulkanIndex',
        component: () => {
          return import('./views/index')
        },
        meta: {
          title: '三维可视化',
        },
      },
    ],
  },
]
